export const SITE_NAME = 'KL Accelerators';

export const DEFAULT_TITLE = 'KL Accelerators - Ready-to-Deploy Solutions for Innovation';

export const DEFAULT_DESCRIPTION =
  'Explore ready-to-deploy enterprise accelerators for rapid development and deployment. Browse by category, tech stack, and use case.';

export const DEFAULT_KEYWORDS =
  'enterprise accelerators, AI agents, rapid development, deployment solutions, KL Accelerators';

export function getSiteUrl() {
  const configured = process.env.REACT_APP_SITE_URL;
  if (configured) {
    return configured.replace(/\/+$/, '');
  }
  if (typeof window !== 'undefined') {
    return window.location.origin.replace(/\/+$/, '');
  }
  return '';
}

export function getDefaultOgImage() {
  const siteUrl = getSiteUrl();
  return siteUrl ? `${siteUrl}/logo.png` : '/logo.png';
}

export function getDefaultRobots() {
  if (process.env.REACT_APP_SEO_ROBOTS) {
    return process.env.REACT_APP_SEO_ROBOTS;
  }

  const appEnv = (process.env.REACT_APP_ENV || '').toLowerCase();
  if (appEnv === 'qa' || appEnv === 'staging' || appEnv === 'development') {
    return 'noindex,nofollow';
  }

  if (appEnv === 'production' || process.env.NODE_ENV === 'production') {
    return 'index,follow';
  }

  return 'noindex,nofollow';
}

export function formatPageTitle(title) {
  if (!title) return DEFAULT_TITLE;
  if (title.includes(SITE_NAME)) return title;
  return `${title} | ${SITE_NAME}`;
}
